import React from 'react';
import clsx from 'clsx';
import loadPianoData from '../../piano_pages_state_manager';

const SubscriptionsSuccess = () => (
  <main className={clsx('group-subscriptions success')}>
    <div className={clsx('group-subscriptions__wrapper')}>
      <div className={clsx('group-subscriptions__container')}>
        <section className={clsx('group-subscriptions__content')}>
          <h1 className={clsx('group-subscriptions__content--hed success')}>
            <span className="primary">Success!</span>
          </h1>

          <div className={clsx('group-subscriptions__content--dek success')}>
            Your information has been received, and we will be in touch shortly.
            If you have any immediate questions, contact us at{' '}
            <a
              href="mailto:subscriptions@fastcompany.com"
              className="underline"
            >
              subscriptions@fastcompany.com
            </a>.
          </div>
        </section>
      </div>
    </div>
  </main>
);

SubscriptionsSuccess.loadData = store => loadPianoData(store);

export default SubscriptionsSuccess;
